import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { show } from '../../slices/toastSlice';
import { fetchRequests } from '../../Requests/getRequests';
import { authStaff } from '../../utils/constants';
import { selectAccessToken } from '../../slices/staffSlice';
import { HugeiconsIcon } from '@hugeicons/react';
import { Search01Icon, UserCircleIcon } from '@hugeicons/core-free-icons';

function SearchClient() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const [phone, setPhone] = useState("");
    const [processing, setProcessing] = useState(false);
    const [searchedClient, setSearchedClient] = useState(null);

    const handleSearch = async (e) => {
        e.preventDefault();
        setProcessing(true);

        if (phone === "") {
            setProcessing(false);
            dispatch(show({ type: "error", state: true, message: "Please enter a phone number" }));
            return;
        }

        let res = await fetchRequests(`/auth/staff/client/search`, "GET", authStaff(accessToken), { phone }, {});
        setProcessing(false);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }
        if (res?.err) {
            dispatch(show({ type: "error", state: true, message: `${res?.err}` }));
            return;
        }

        setSearchedClient(res);
    };

    return (
        <div className='section-container md:py-2 py-0'>
            <div className='bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-xl shadow-sm p-6'>
                <div className='mb-5'>
                    <h2 className='text-base font-semibold text-gray-900 dark:text-gray-50'>Search Clients</h2>
                    <p className='text-sm text-gray-500 dark:text-gray-400 mt-0.5'>Look up a client account by phone number.</p>
                </div>

                <form className='flex flex-wrap gap-3 items-end' onSubmit={handleSearch}>
                    <div className='flex-1 min-w-64'>
                        <label htmlFor="client-phone" className="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">
                            Phone Number
                        </label>
                        <input
                            type="text"
                            name="client-phone"
                            id="client-phone"
                            className='form-input'
                            placeholder='e.g. 0244000000'
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={processing}
                        className='flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium text-white transition-colors disabled:opacity-60'
                        style={{ backgroundColor: '#1e3a6e' }}
                    >
                        <HugeiconsIcon icon={Search01Icon} size={16} />
                        {processing ? 'Searching…' : 'Search'}
                    </button>
                </form>

                {searchedClient && searchedClient?._id && (
                    <div className='mt-6'>
                        <p className='text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3'>Result</p>
                        <Link
                            to={`/client/${searchedClient?._id}`}
                            className='flex items-center gap-3 px-4 py-3.5 border border-gray-100 dark:border-gray-700 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors'
                        >
                            <div className='w-9 h-9 rounded-full bg-blue-50 flex items-center justify-center shrink-0'>
                                <HugeiconsIcon icon={UserCircleIcon} size={18} className='text-blue-600' />
                            </div>
                            <div>
                                <p className='text-sm font-medium text-gray-900 dark:text-gray-100'>
                                    {searchedClient?.otherNames} {searchedClient?.surname}
                                </p>
                                <p className='text-xs text-gray-500'>{phone}</p>
                            </div>
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SearchClient;
